import Page from "webPage/Page";
import CanvasImage from "CanvasImage";
import Gallery from "base/Gallery";
import GlobalEvents from "base/GlobalEvents";

Page.register(new RegExp('/(projects|news-and-events)/([a-z0-9-]+)/?'), function () {

    new Gallery($(".js-gallery"), {
        animationDuration: 0
    });

    let masksOtherProjects = {
        0: [
            {
                'url': '/images/png/masks/project-inner/other-projects-mask--huge.png',
                'vPos': 'top'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/project-inner/other-projects-mask--huge.png',
                'vPos': 'top'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/project-inner/other-projects-mask--huge.png',
                'vPos': 'top'
            }
        ],
        1180: [
            {
                'url': '/images/png/masks/project-inner/other-projects-mask--huge.png',
                'vPos': 'top'
            }
        ],
        1400: [
            {
                'url': '/images/png/masks/project-inner/other-projects-mask--huge.png',
                'vPos': 'top'
            }
        ]
    };

    new CanvasImage($('.other-projects__image'), masksOtherProjects);


    $("body").on("mouseover focus", ".js-equip-highlight", () => {
        let $tooltip = $(".js-equip-tooltip");
        let $link = $(".js-equip-highlight");

        $tooltip.css({top: $link.position().top, left: $link.position().left});

        $("body").addClass("show-tooltip").attr("aria-hidden", "false");
    }).on("mouseout blur", ".js-equip-highlight", () => $("body").removeClass("show-tooltip").attr("aria-hidden", true));

    function updateEquipHighlight() {
        disableEquipHighlight();
        if ($("body").is(".was-equip")) {
            let $content = $("[data-field='content-top']");

            $content.html($content.html().replace(/EQuIP([.,!;'" *]|&nbsp;)/i, '<mark aria-describedby="wrep-tooltip" tabindex="0" class="js-equip-highlight">EQuIP</mark>$1'))
        }
    }

    function disableEquipHighlight() {
        let $highlight = $(".js-equip-highlight");

        if ($highlight.length > 0) {
            $highlight.after($highlight.text()).remove();
        }
        $("body").removeClass("show-tooltip");
    }

    GlobalEvents.on("update-equip-highlight", () => updateEquipHighlight());
    GlobalEvents.on("disable-equip-highlight", () => disableEquipHighlight());

    updateEquipHighlight();
});

